import { useFetchData } from "../../../hooks/useFetch";

import { ApiConfig, API_PAYMENT_PARTNER_ROUTER } from "../../../services/api-config";

export type PaymentPartner = {
  id: string; 
  api_key: string;
  client_id: string;
  checksum_key: string;
  created_at: Date;
  updated_at: Date;
};

export interface PaymentPartnersSettingPayload {
    client_id: string;
    api_key: string;
    checksum_key: string;
}

export interface SettingPaymentResponse{
  massage: string;
}

export interface CancelPaymentResponse{
  massage: string;
}

export const SettingPaymentService = {
    getPaymentDetail: () => {
      const { request, baseResponse, loading } = useFetchData.Get<PaymentPartner>({
        projectId: ApiConfig.PROJECT_ID.PAYMENT_SERVICE,
      });
      return {
        fetch: () =>
          request({
            endPoint: API_PAYMENT_PARTNER_ROUTER.API_PAYMENT_DETAIL,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    settingPayment: () => {
      const { request, baseResponse, loading } = useFetchData.Post<SettingPaymentResponse>({
        projectId: ApiConfig.PROJECT_ID.PAYMENT_SERVICE,
      });
      return {
        fetch: (payload: PaymentPartnersSettingPayload) =>
          request({
            endPoint: API_PAYMENT_PARTNER_ROUTER.API_PAYMENT_SETTING(),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    cancelPayment: () => {
      const { request, baseResponse, loading } = useFetchData.Post<CancelPaymentResponse>({
        projectId: ApiConfig.PROJECT_ID.PAYMENT_SERVICE,
      });
      return {
        fetch: () =>
          request({
            endPoint: API_PAYMENT_PARTNER_ROUTER.API_CANCEL_SETTING(),
          }),
        response: baseResponse,
        loading: loading,
      }
    },
};

export default SettingPaymentService;
